import { render, staticRenderFns } from "./GestioneAttivitaProdottiListPage.vue?vue&type=template&id=42380b77"
import script from "./GestioneAttivitaProdottiListPage.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaProdottiListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports